// GAVION full-email: « Voir le courriel » from the CRM's stored copy, and « Archive de boîte courriel » (admins).
export const emailArchiveFr = {
  viewer: {
    archived_on: "Copie archivée le %{date}",
    truncated: "message tronqué (trop long)",
    pending: "Copie complète en cours d'enregistrement.",
    download: "Télécharger %{name}",
    not_kept: "non conservé : %{reason}",
    reasons: {
      pending: "en cours d'enregistrement",
      skipped_inline: "image intégrée",
      skipped_type: "type non conservé",
      skipped_size: "trop volumineux",
      skipped_cap: "trop volumineux",
      skipped_item: "pièce jointe Outlook",
      failed: "échec de l'enregistrement",
    },
  },
  card: {
    title: "Archive de boîte courriel",
    description:
      "Conserve dans le CRM, en entier, les courriels liés à une compagnie ou un contact d'un représentant qui a quitté. La boîte est lue avec votre compte Microsoft, par délégation.",
    source: "Boîte à archiver",
    source_none: "Aucun utilisateur désactivé.",
    mailbox: "Boîte : %{email}",
    mailbox_unknown:
      "Le CRM ne connaît pas l'identifiant Microsoft de cette boîte (ce représentant ne s'est jamais connecté à Outlook dans le CRM).",
    reconnect:
      "Reconnectez Outlook (nouvelle autorisation « Lire les boîtes partagées »).",
    step1: "Étape 1 — Délégation",
    delegation_1:
      "Centre d'administration Microsoft 365 → Utilisateurs → Utilisateurs actifs → %{name}.",
    delegation_2: "Gardez sa licence. Choisissez « Bloquer la connexion ».",
    delegation_3:
      "Courrier → Autorisations de boîte aux lettres → « Lire et gérer (Accès total) » → ajoutez le compte Microsoft connecté au CRM.",
    delegation_4:
      "Attendez jusqu'à 60 minutes, puis vérifiez l'accès ici. Ne convertissez pas et ne supprimez pas la boîte avant la fin.",
    confirm_delegation:
      "J'ai donné à mon compte Microsoft l'accès complet à la boîte de %{name}",
    check: "Vérifier l'accès",
    folders:
      "%{smart_count} dossier trouvé |||| %{smart_count} dossiers trouvés",
    folder_row: "%{name} — %{total} éléments",
    step2: "Étape 2 — Lancer l'archivage",
    start: "Lancer l'archivage",
    confirm_title: "Lancer l'archivage ?",
    confirm_body:
      "Seuls les courriels liés à une compagnie ou un contact du CRM seront conservés, en entier, au nom de %{name}. Les autres ne sont pas copiés.",
    status: {
      checking: "Vérification",
      ready: "Prêt",
      running: "En cours",
      paused: "En pause",
      blocked: "Bloqué",
      done: "Terminé",
      cancelled: "Annulé",
    },
    counts: {
      seen: "Vus",
      archived: "Archivés",
      already_in_crm: "Déjà dans le CRM",
      skipped_unlinked: "Non liés (ignorés)",
      skipped_ignored: "Ignorés (invitations, envois à soi-même)",
      skipped_retention: "Ignorés — période de conservation dépassée",
      private: "Privés",
      failed: "Échecs",
      pending: "Copies en attente",
      stored: "Copies enregistrées",
      files: "Pièces jointes conservées",
      bytes: "Taille conservée",
    },
    folder_progress: "%{name} : %{seen} / %{total}",
    folder_gone: "%{name} : %{seen} / %{total} (dossier disparu, ignoré)",
    pause: "Pause",
    resume: "Reprendre",
    cancel: "Annuler",
    retry_failed: "Relancer les échecs",
    cancel_title: "Annuler l'archivage ?",
    cancel_body: "Ce qui est déjà enregistré est conservé.",
    report: "Rapport final",
    duration: "Durée : %{minutes} min",
    failures: "Échecs par code",
    failure_forbidden: "Accès refusé par Microsoft",
    online_archive:
      "L'archive en ligne Exchange n'est pas accessible par Microsoft Graph : si le centre d'administration en montre une, elle n'est pas copiée.",
    license_hint:
      "Une fois « Terminé » et le rapport lu, vous pouvez retirer la licence et l'accès total.",
  },
  errors: {
    forbidden: "Réservé aux administrateurs.",
    unauthorized: "Session expirée : reconnectez-vous au CRM.",
    m365_not_configured:
      "Microsoft 365 n'est pas encore configuré pour le CRM.",
    archive_failed:
      "L'archivage a échoué de façon inattendue : réessayez ou contactez le soutien.",
    archive_rpc_failed:
      "Le CRM n'a pas pu enregistrer l'archivage : réessayez dans un moment.",
    invalid_mailbox:
      "Identifiant de boîte invalide : l'archivage ne peut pas lire cette boîte.",
    db_unavailable:
      "La base de données est indisponible : réessayez dans un moment.",
    reader_not_admin:
      "Le compte Microsoft connecté n'est plus celui d'un administrateur : reconnectez-vous avec un compte administrateur.",
    attachment_too_large:
      "Une pièce jointe est trop volumineuse pour être conservée.",
    job_not_running: "L'archivage n'est pas en cours.",
    method_not_allowed: "Action non permise.",
    graph_timeout: "Microsoft a tardé à répondre : réessayez dans un moment.",
    source_active: "Ce représentant est encore actif : désactivez-le d'abord.",
    reader_not_connected: "Connectez d'abord votre compte Microsoft 365.",
    mailbox_unknown:
      "Le CRM ne connaît pas l'identifiant Microsoft de cette boîte (ce représentant ne s'est jamais connecté à Outlook dans le CRM).",
    invalid_body: "Demande invalide.",
    job_open: "Un archivage est déjà ouvert pour cette boîte.",
    not_found: "Introuvable.",
    invalid_state: "Action impossible dans l'état actuel.",
    scope_missing:
      "Reconnectez Outlook (nouvelle autorisation « Lire les boîtes partagées »).",
    delegation_missing:
      "Accès refusé : votre compte Microsoft n'a pas l'accès complet à la boîte de %{name} (délégation manquante ou pas encore active — jusqu'à 60 min).",
    mailbox_not_found: "Boîte introuvable (licence retirée ?).",
    microsoft_needs_reauth:
      "Votre connexion Microsoft a expiré : reconnectez Outlook.",
    reader_needs_reauth:
      "Votre connexion Microsoft a expiré : reconnectez Outlook, puis « Reprendre ».",
    too_many_folders:
      "Plus de 200 dossiers : l'archivage ne peut pas les parcourir tous.",
    no_folders: "Aucun dossier à archiver.",
    graph_throttled: "Microsoft limite les accès : réessayez dans un moment.",
    graph_unavailable: "Microsoft est indisponible : réessayez dans un moment.",
    unknown: "Erreur inattendue.",
    storage_upload_failed:
      "Une pièce jointe n'a pas pu être enregistrée dans le CRM : réessayez plus tard.",
    attachment_unsupported: "Type de pièce jointe non conservé.",
  },
};
